import { useState } from "react";
import { ArrowLeft, MoreVertical } from "lucide-react";

// Componente maestro reutilizable: encabezado + menú de acciones (tres puntos).
// actions: [{ label, icon, onClick, danger, testid }]
export function DocDetailHeader({ title, subtitle, onClose, backLabel = "Volver a la lista", actions = [] }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="sticky top-0 z-30 flex items-center justify-between bg-white border-b border-[#E3E8EE] px-5 h-16">
      <div className="flex items-center gap-4 min-w-0">
        <button
          onClick={onClose}
          data-testid="doc-detail-close"
          className="flex items-center gap-2 shrink-0 rounded-full border border-[#E3E8EE] pl-2.5 pr-3.5 py-1.5 font-mono-data text-sm font-semibold text-[#465B7F] hover:bg-[#E9EEF3] hover:border-[#465B7F] transition-colors"
        >
          <ArrowLeft size={17} />
          {backLabel}
        </button>
        <div className="min-w-0">
          <div className="font-display font-bold text-lg text-[#16202B] truncate leading-tight">{title}</div>
          {subtitle && <div className="font-mono-data text-xs text-[#5B6672] truncate">{subtitle}</div>}
        </div>
      </div>
      <div className="relative">
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid="doc-actions-menu"
          className="flex items-center justify-center h-10 w-10 rounded-full text-[#465B7F] hover:bg-[#E9EEF3] transition-colors"
        >
          <MoreVertical size={20} />
        </button>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <div className="absolute right-0 mt-2 w-52 bg-white border border-[#E3E8EE] shadow-xl z-50 py-1" data-testid="doc-actions-dropdown">
              {actions.map((a) => (
                <button
                  key={a.label}
                  onClick={() => { setOpen(false); a.onClick(); }}
                  data-testid={a.testid}
                  className={`w-full flex items-center gap-3 px-4 py-2.5 font-mono-data text-sm transition-colors hover:bg-[#E9EEF3] ${
                    a.danger ? "text-[#ED1F26]" : "text-[#16202B]"
                  }`}
                >
                  {a.icon}
                  {a.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
